

import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import SearchCompetitorProfile from "./SearchCompetitorProfile";

import { useState, useContext, useEffect } from "react";
import { AuthContext } from "context";
import AuthService from "services/auth-service";
import PlatformScoutIntroStep from "layouts/tutorial/steps/PlatformScoutIntroStep";
import PlatformScoutGuidanceStep from "layouts/guidance/steps/PlatformScoutGuidanceStep";
import PlatformScoutGuidance from "layouts/guidance/components/PlatformScoutGuidance";

function PlatformScout() {
  const { isAuthenticated } = useContext(AuthContext);
  const [showTutorial, setShowTutorial] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const isLiveDemo = sessionStorage.getItem('demo_role_cache') === "demo_viewer";


  useEffect(() => {
    if (!isAuthenticated) return;

    const checkTutorial = async () => {
      try {
        const resp = await AuthService.getProfile();
        const userData = resp.data.attributes;
        setCurrentUser(userData);

        const completedSteps = userData.completed_tutorials || [];
        if (!completedSteps.includes("platform_scout_intro")) {
          setShowTutorial(true);
        }
      } catch (error) {
        console.error("Failed to check tutorial status:", error);
      }
    };
    checkTutorial();
  }, [isAuthenticated]);

  const handleCompleteTutorial = async () => {
    try {
      const currentCompleted = currentUser?.completed_tutorials || [];
      if (!currentCompleted.includes("platform_scout_intro")) {
        const updatedTutorials = [...currentCompleted, "platform_scout_intro"];
        await AuthService.updateProfile({
          data: { attributes: { completed_tutorials: updatedTutorials } }
        });
      }
      setShowTutorial(false);
    } catch (error) {
      console.error("Failed to complete tutorial:", error);
      setShowTutorial(false);
    }
  };

  // 🟢 Guidance Overlay State
  const [showGuidanceOverlay, setShowGuidanceOverlay] = useState(false);

  useEffect(() => {
    // Check if we should show the overlay (Live Demo + Not Shown Yet)
    const hasShown = sessionStorage.getItem("platform_scout_intro_shown");
    if (isLiveDemo && !hasShown && !showTutorial) {
      setShowGuidanceOverlay(true);
    }
  }, [isLiveDemo, showTutorial]);

  const handleDismissGuidance = () => {
    setShowGuidanceOverlay(false);
    sessionStorage.setItem("platform_scout_intro_shown", "true");

    // [NEW] Mark this module as completed for the tour
    if (isLiveDemo) {
      sessionStorage.setItem("demo_visited_scout", "true");
      window.dispatchEvent(new Event('demoVisitUpdated'));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* 🟢 DEMO GUIDANCE - Slides from top */}
      <PlatformScoutGuidanceStep
        isLiveDemo={isLiveDemo}
        showOverlay={showGuidanceOverlay} // [NEW] Control visibility
      />

      {/* 🟢 DEMO NEXT STEP GUIDANCE */}
      <PlatformScoutGuidance />

      <MDBox pt={6} pb={6}>
        <SearchCompetitorProfile
          isGuidanceActive={showGuidanceOverlay} // [NEW] For highlighting
          onSearchStart={handleDismissGuidance}   // [NEW] To dismiss overlay
        />
      </MDBox>
      <Footer />

      {/* Tutorial Popup */}
      <PlatformScoutIntroStep
        open={showTutorial && !isLiveDemo}
        onComplete={handleCompleteTutorial}
        onSkip={() => setShowTutorial(false)}
      />
    </DashboardLayout>
  );
}

export default PlatformScout;

